import React from 'react';
import PropTypes from 'prop-types';
import style from './CustomToggle.module.css';

const CustomToggle = ({ items, selectedItem, handleToggle }) => {
  return (
    <>
      {items.map((item, i) => (
        <div key={i} className={style.reportTabs}>
          <button
            className={`${style.reportTab} ${selectedItem === item.key ? style.active : ''}`}
            onClick={() => handleToggle(item.key)}
          >
            {item.label}
          </button>
        </div>
      ))}
    </>
  );
};

CustomToggle.propTypes = {
  items: PropTypes.array,
  selectedItem: PropTypes.string,
  handleToggle: PropTypes.func,
};

export default CustomToggle;
